import * as React from 'react';

interface Props<T> {
    options: T[];
    onOptionSelected: (option: T) => void;
    getFriendlyNameForOptions: (option: T) => string;
    getUniqueValueForOption: (option: T) => string;
    preselectedOption?: T;
    id?: string;
    value?: T;
    isDisabled?: boolean;
}

interface State<T> {
    currentSelectedValue: T;
}
/**
 * Renders a standard <select><option>...</select> drop down menu.
 * Note: this component will auto select the first object in the
 * props to mimic a regular html select.
 */
export class DropdownMenu<T> extends React.PureComponent<Props<T>, State<T>> {
    public constructor(props: Props<T>) {
        super(props);
        let value;
        value = this.props.value ? this.props.getUniqueValueForOption(this.props.value) : '';
        if (value === '') {
            this.state = {
                currentSelectedValue: this.props.preselectedOption as unknown as T ?? this.props.options[0]
            };
        }
        else
        {
            this.state = {
                currentSelectedValue: this.props.value as unknown as T ?? this.props.options[0]
            };
        }
    }

    public componentDidMount() {
        if (this.props.options.length === 0) {
            return;
        }

        // start off with one selected
        this.props.onOptionSelected(this.state.currentSelectedValue);
    }

    public render() {
        return (
            <select disabled={this.props.isDisabled} id={this.props.id} className="form-control" onChange={this.select_onChange} value={this.props.getUniqueValueForOption(this.props.value ?? this.state.currentSelectedValue).coalesceToMaxSizeAndIndicateTruncationWithEllipsis(128)}>
                {this.props.options.map((o, i) => (
                    <option key={i} value={this.props.getUniqueValueForOption(o)}>{this.props.getFriendlyNameForOptions(o).coalesceToMaxSizeAndIndicateTruncationWithEllipsis(128)}</option>
                ))}
            </select>
        );
    }

    private selectOnChange(value: string) {
        const option = this.props.options.find(o => this.props.getUniqueValueForOption(o) === value);
        if (!option) {
            return;
        }
        this.setState({
            currentSelectedValue: option
        });
        this.props.onOptionSelected(option);
    }

    private select_onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.selectOnChange(e.target.value);
    }
}